import { getUserCertification as publicGetUserCertification } from './academy-certifications-v1-user-certification-user-certifications.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getUserCertification: MaybeContext<
  BuildRESTFunction<typeof publicGetUserCertification> &
    typeof publicGetUserCertification
> = /*#__PURE__*/ createRESTModule(publicGetUserCertification);

export {
  CertificationType,
  SortOrder,
  WebhookIdentityType,
} from './academy-certifications-v1-user-certification-user-certifications.universal.js';
export {
  UserCertification,
  CreateUserCertificationRequest,
  CreateUserCertificationResponse,
  GetUserCertificationRequest,
  GetUserCertificationResponse,
  DeleteUserCertificationRequest,
  DeleteUserCertificationResponse,
  QueryUserCertificationsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryUserCertificationsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
} from './academy-certifications-v1-user-certification-user-certifications.universal.js';
export {
  CertificationTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './academy-certifications-v1-user-certification-user-certifications.universal.js';
